import Api from 'services/api';

export const getBrandBySlug = (insuranceCompanySlug, expand = []) => {
  return new Promise((resolve, reject) => {
    Api.get(`/brands/${insuranceCompanySlug}`, { params: { expand } })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getBrands = (expand = ['brand.products']) => {
  return new Promise((resolve, reject) => {
    Api.get('/brands', { params: { expand } })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
